import React from 'react'
import { useTheme, Box, Link } from '@mui/material'
import { Spinner, theme } from 'packages/eid-ui'

const ActionButton = (props) => {
    const theme = useTheme()

    const {
        width,
        height,
        bgColor,
        hoverColor,
        border,
        fontColor,
        children,
        loading,
        onClick,
        disabled,
        loaderColor,
        disabledColor = theme?.palette?.disabled?.main,
        minWidth = '120px',
        ...rest
    } = props

    return (
        <Link
            component="button"
            underline="none"
            onClick={disabled || loading ? undefined : onClick}
            style={{ width: width ? width : '100%', minWidth: minWidth }}
            {...rest}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '5px',
                    width: width,
                    height: height,
                    paddingLeft: '8px',
                    paddingRight: '8px',
                    backgroundColor: disabled ? disabledColor : bgColor,
                    border: border,
                    color: fontColor
                        ? fontColor
                        : theme?.palette?.common?.white,
                    opacity: disabled ? 0.8 : 1,
                    minWidth: minWidth,
                    '&:hover': {
                        cursor: disabled || loading ? 'initial' : 'pointer',
                        backgroundColor: hoverColor,
                    },
                }}
            >
                {loading && <Spinner size={0.8} color={loaderColor} />}
                {!loading && children}
            </Box>
        </Link>
    )
}

ActionButton.defaultProps = {
    width: '100px',
    height: '48px',
    bgColor: theme?.palette?.common?.white,
    border: 'none',
    loaderColor: theme?.palette?.common?.white,
}

export default ActionButton
